import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/Facebook_Logo_Secondary.png")